export var getDetailsUrlPage = function getDetailsUrlPage() {
  var _document;
  if (typeof window === 'undefined') {
    return {
      url: '',
      path: '',
      title: ''
    };
  }
  var _window = window,
    location = _window.location;
  return {
    url: "".concat(location.protocol, "//").concat(location.hostname).concat(location.pathname),
    path: location.pathname,
    title: ((_document = document) === null || _document === void 0 ? void 0 : _document.title) || ''
  };
};